var _rect, _path, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNewVoteIconTwoGreenStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.50586,
    y: 4.25,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    fill: "#4ED4A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0716 25H23.4949V23.9062H18.7619V23.8267L21.0488 21.3807C22.7988 19.5064 23.3159 18.6314 23.3159 17.5028C23.3159 15.9318 22.0431 14.679 20.2534 14.679C18.4686 14.679 17.1113 15.892 17.1113 17.6818H18.2846C18.2846 16.5234 19.0353 15.7528 20.2136 15.7528C21.3173 15.7528 22.1625 16.429 22.1625 17.5028C22.1625 18.4425 21.6106 19.1385 20.4324 20.4261L17.0716 24.1051V25Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.50586,
    y: 4.25,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    stroke: "#4ED4A9",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.755859,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#4ED4A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewVoteIconTwoGreenStep);
export default __webpack_public_path__ + "static/media/AddNewVoteIconTwoGreenStep.53a824c4891f2e34a07479ca6e6ece30.svg";
export { ForwardRef as ReactComponent };